import { lazy } from 'react';

export const YourBirthTimePageLazy = lazy(() => import('./your-birthtime'));
